import styled from 'styled-components'

import { Text, truncateStyles, Dropdown } from '@sketch/components'

export const Label = styled(Text)`
  ${truncateStyles};
  flex: 1;
  max-width: calc(100% - 1rem);
`

export const DropdownContent = styled.div`
  width: 100%;
  max-height: 40vh;
  overflow-y: auto;
`
export const StyledDropdown = styled(Dropdown)`
  width: 100%;
`
